import { Link } from 'react-router-dom'

import { Button, CriticalIcon, EmptyState } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

/**
 * Empty state for a single-channel insights route whose channel no longer
 * resolves (removed, disconnected, or a stale bookmark). Mirrors the publish
 * channel page's "Channel not found" state so the two surfaces stay consistent.
 */
export function InsightsChannelNotFound(): JSX.Element {
  return (
    <EmptyState size="xlarge" variant="neutral">
      <EmptyState.Icon>
        <CriticalIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>Channel not found</EmptyState.Heading>
      <EmptyState.Description>
        This channel does not exist or is no longer connected.
      </EmptyState.Description>
      <EmptyState.Actions>
        <Button as={Link} to="/insights" size="large">
          Back to Insights
        </Button>
      </EmptyState.Actions>
    </EmptyState>
  )
}
